import { AppsListDetail24Filled, ArrowCircleDown24Regular } from "@fluentui/react-icons";
import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuProps,
  MenuTrigger,
} from "@fluentui/react-components";

import React from "react";

interface DrillDownMenuProps {
  data: { category: string; types: string[] }[];
  onSelect: (key: string) => void;
}

const CategorySubMenu: React.FC<{
  category: string;
  types: string[];
  onSelect: (key: string) => void;
}> = ({ category, types, onSelect }) => {
  const [open, setOpen] = React.useState(false);

  const onOpenChange: MenuProps["onOpenChange"] = (e, data) => {
    setOpen(data.open);
  };

  return (
    <Menu open={open} onOpenChange={onOpenChange}>
      <MenuTrigger disableButtonEnhancement>
        <MenuItem>{category}</MenuItem>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          {types.map((type) => (
            <MenuItem
              key={`${category}:${type}`}
              onClick={() => onSelect(`${category}:${type}`)}
            >
              {type}
            </MenuItem>
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};

const DrillDownMenu: React.FC<DrillDownMenuProps> = ({ data, onSelect }) => {
  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        <MenuButton appearance="primary" icon={<AppsListDetail24Filled />}>
          Drill Down
        </MenuButton>
      </MenuTrigger>

      <MenuPopover>
        <MenuList>
          {data.map(({ category, types }) => (
            <CategorySubMenu
              key={category}
              category={category}
              types={types}
              onSelect={onSelect}
            />
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};

export default DrillDownMenu;
